// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class ScrollIndicator extends Vue {
  public onClick(event) {
    event.preventDefault();
    let elem = this.$el as HTMLElement;
    let box = elem.getBoundingClientRect();
    let topPos = box.top + box.height + document.documentElement.scrollTop;
    window.scroll({ top: topPos, left: 0, behavior: "smooth" });
  }
}
